export const defaultFormState = {
    isLoading: false,
    isFormInvalid: true,
    mainError: '',
    dirtyFields: {}
};
